import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { ProcurementDemandListTableColumn } from "./ProcurementDemandListTableColumn";

import { useDemandList } from "@hooks/procurements/demand/useDemandList";
import { DemandResponseType } from "@type/procurements/demand";
import { Pagination } from "@type/procurements/pagination";

import { TablePagination } from "@helpers/tablePagination";

export default function ProcurementDemandListTable() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { handleQuery, demandState } = useDemandList();

  const { getData, createSuccess, deleteSuccess } = demandState;

  const { data, pagination } = getData || ({} as DemandResponseType);
  const { page, total } = pagination || ({} as Pagination);

  useEffect(() => {
    if (createSuccess === true) handleQuery("page", 1);
    else if (deleteSuccess === true) handleQuery("page", page);
  }, [createSuccess, deleteSuccess]);

  return (
    <Table
      header={{
        title: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE_HEADING"),
        badge: {
          label: `${total}`,
          size: "sm",
          type: "primary",
        },
      }}
      // actions={[
      //   {
      //     customIcon: <IconEye size="20" />,
      //     onClick: (id) => {
      //       navigate(`${id}`);
      //     },
      //   },
      // ]}
      columns={ProcurementDemandListTableColumn(t, navigate)}
      rows={data || []}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
}
